export default {
  description: 'Paste JSON for a RenderRoot or a single render element to preview how it is rendered.',
  jsonInputPlaceholder: 'Paste RenderRoot or render element JSON here',
  validationErrorSummary: 'Preview not available',
  errors: {
    emptyInput: 'Input is empty. Paste JSON to start the preview.',
    unknownJsonError: 'Unknown JSON parsing error.',
    invalidJson: 'Invalid JSON syntax: {details}',
  },
};
